/**
 * Horizontal inset of a row in a driver thread inside the driver workspace.
 *
 * The bubble's `max-w` is relative to its row, so the inset is what decides
 * how wide a bubble may grow — and an inset that differed per sender is what
 * made the dispatcher's bubble and Slick AI's different widths. `Message`
 * applies it to every row it renders; the handful of rows that are not a
 * `Message` (the day marker, the internal Slick AI chips, the chat-state
 * indicator) read it from here, so one value still answers the question for
 * the whole thread.
 *
 * Its own leaf module on purpose: a row as small as the day marker should not
 * have to import the whole message component — and its test mocks, which do
 * not expect that module graph — to learn one class name.
 */
export const MESSAGE_ROW_INSET = "mx-7"
